export const CANONICAL_BASE = 'https://nexusdesignai.com';

const T = (en, tr) => ({ en, tr });

// Public routes: unique title + description per route. Anything not listed here
// falls back to noindex when listed in PRIVATE_PREFIXES, or the default config.
export const SEO_ROUTES = {
  '/': {
    title: T('Nexus Design AI — AI-Native Engineering Design Platform', 'Nexus Design AI — AI Tabanlı Mühendislik Tasarım Platformu'),
    description: T(
      'Turn plain-language requirements into preliminary, reviewable specifications, BOM, cost and validation-planning outputs with AI assistance.',
      'Sade dille yazılmış gereksinimleri AI desteğiyle incelenebilir ön spesifikasyon, BOM, maliyet ve doğrulama planı çıktılarına dönüştürün.'
    ),
  },
  '/pricing': {
    title: T('Pricing — Nexus Design AI', 'Fiyatlandırma — Nexus Design AI'),
    description: T(
      'Free, Pro ($19.99/month) and Enterprise (custom) plans for AI-assisted engineering workflows. Refund eligibility is subject to the published terms.',
      'AI destekli mühendislik iş akışları için Free, Pro ($19.99/ay) ve Enterprise (özel) planları. İade uygunluğu yayınlanan koşullara tabidir.'
    ),
  },
  '/investor': {
    title: T('Investor Overview — Nexus Design AI', 'Yatırımcı Özeti — Nexus Design AI'),
    description: T(
      'Investment overview for Nexus Design AI: patent-pending workflows, verifiable product evidence and roadmap.',
      'Nexus Design AI yatırım özeti: patent başvurulu iş akışları, doğrulanabilir ürün kanıtı ve yol haritası.'
    ),
  },
  '/acquire': {
    title: T('Acquisition & IP Portfolio — Nexus Design AI', 'Satın Alma ve IP Portföyü — Nexus Design AI'),
    description: T(
      'Acquisition inquiry for a patent-pending AI-native engineering platform. Filing and claim details are available only under NDA during legal due diligence.',
      'Patent başvurusu devam eden AI-native mühendislik platformu için satın alma görüşmesi. Dosyalama ve talep ayrıntıları yalnızca NDA kapsamında hukuki inceleme sırasında paylaşılır.'
    ),
  },
  '/projects': {
    title: T('Public Project Gallery — Nexus Design AI', 'Herkese Açık Proje Galerisi — Nexus Design AI'),
    description: T(
      'Browse public AI-generated engineering projects. Sensitive engineering data is protected behind sign-in.',
      'Herkese açık AI üretimi mühendislik projelerine göz atın. Hassas mühendislik verileri giriş korumalıdır.'
    ),
  },
  '/engines': {
    title: T('Validation Architecture — Nexus Design AI', 'Doğrulama Mimarisi — Nexus Design AI'),
    description: T(
      'Review Nexus workflow boundaries, validation gates, preliminary outputs and human sign-off requirements.',
      'Nexus iş akışı sınırlarını, doğrulama kapılarını, ön çıktıları ve insan onayı gereksinimlerini inceleyin.'
    ),
  },
  '/marketplace': {
    title: T('Marketplace — Nexus Design AI', 'Pazar Yeri — Nexus Design AI'),
    description: T(
      'Design templates, engineering kits and licensing options on the Nexus Design AI marketplace.',
      'Nexus Design AI pazar yerinde tasarım şablonları, mühendislik kitleri ve lisans seçenekleri.'
    ),
  },
  '/licensing': {
    title: T('Enterprise Licensing — Nexus Design AI', 'Kurumsal Lisanslama — Nexus Design AI'),
    description: T(
      'Exclusive, non-exclusive and strategic partnership licensing tiers for the Nexus Design AI IP portfolio.',
      'Nexus Design AI IP portföyü için özel, açık ve stratejik ortaklık lisans seviyeleri.'
    ),
  },
  '/integrations': {
    title: T('Integrations — Nexus Design AI', 'Entegrasyonlar — Nexus Design AI'),
    description: T(
      'Current, configurable and roadmap integrations for CAD, patent search, 3D workflows and enterprise systems.',
      'CAD, patent araması, 3B iş akışları ve kurumsal sistemler için mevcut, yapılandırılabilir ve roadmap entegrasyonları.'
    ),
  },
  '/about': {
    title: T('About — Nexus Design AI', 'Hakkımızda — Nexus Design AI'),
    description: T(
      'Nexus Design AI develops AI-assisted, validation-first workflows for preliminary engineering and product-development decisions.',
      'Nexus Design AI, ön mühendislik ve ürün geliştirme kararları için AI destekli, doğrulama-öncelikli iş akışları geliştirir.'
    ),
  },
  '/blog': {
    title: T('Blog — Nexus Design AI', 'Blog — Nexus Design AI'),
    description: T(
      'Articles on AI-powered design, Industry 4.0, 3D prototyping and engineering trends.',
      'AI destekli tasarım, Endüstri 4.0, 3D prototipleme ve mühendislik trendleri üzerine yazılar.'
    ),
  },
  '/contact': {
    title: T('Contact — Nexus Design AI', 'İletişim — Nexus Design AI'),
    description: T(
      'Get in touch with the Nexus Design AI team for demos, licensing and support.',
      'Demo, lisanslama ve destek için Nexus Design AI ekibiyle iletişime geçin.'
    ),
  },
  '/faq': {
    title: T('FAQ — Nexus Design AI', 'SSS — Nexus Design AI'),
    description: T(
      'Frequently asked questions about plans, refunds, engineering outputs and data protection.',
      'Planlar, iadeler, mühendislik çıktıları ve veri koruması hakkında sık sorulan sorular.'
    ),
  },
  '/privacy-policy': {
    title: T('Privacy Policy — Nexus Design AI', 'Gizlilik Politikası — Nexus Design AI'),
    description: T(
      'How Nexus Design AI collects, uses and protects data, including current privacy-readiness measures.',
      'Nexus Design AI verileri nasıl toplar, kullanır ve korur; mevcut gizlilik hazırlığı önlemleri.'
    ),
  },
  '/security': {
    title: T('Trust & Security — Nexus Design AI', 'Güven ve Güvenlik — Nexus Design AI'),
    description: T(
      'Where Nexus Design AI processes your design data, which security controls are in place, the subprocessor list, retention periods and what is not certified yet.',
      'Nexus Design AI tasarım verinizi nerede işler, hangi güvenlik kontrolleri uygulanır, alt işleyici listesi, saklama süreleri ve henüz sertifikalı olmayan konular.'
    ),
  },
  '/trust': {
    title: T('Trust & Security — Nexus Design AI', 'Güven ve Güvenlik — Nexus Design AI'),
    description: T(
      'Where Nexus Design AI processes your design data, which security controls are in place, the subprocessor list, retention periods and what is not certified yet.',
      'Nexus Design AI tasarım verinizi nerede işler, hangi güvenlik kontrolleri uygulanır, alt işleyici listesi, saklama süreleri ve henüz sertifikalı olmayan konular.'
    ),
  },
  '/security-policy': {
    title: T('Security Policy — Nexus Design AI', 'Güvenlik Politikası — Nexus Design AI'),
    description: T(
      'Responsible vulnerability disclosure policy and security contact for Nexus Design AI.',
      'Nexus Design AI sorumlu güvenlik açığı bildirim politikası ve güvenlik iletişim bilgisi.'
    ),
  },
  '/terms-of-service': {
    title: T('Terms of Service — Nexus Design AI', 'Kullanım Koşulları — Nexus Design AI'),
    description: T(
      'Terms of service, plan pricing, refund policy and IP ownership rules for Nexus Design AI.',
      'Nexus Design AI kullanım koşulları, plan fiyatları, iade politikası ve fikri mülkiyet kuralları.'
    ),
  },
  '/case-studies': {
    title: T('Workflow Scenarios — Nexus Design AI', 'İş Akışı Senaryoları — Nexus Design AI'),
    description: T(
      'Illustrative scenarios showing how AI-generated engineering packages accelerate design work.',
      'AI üretimi mühendislik paketlerinin tasarım işini nasıl hızlandırdığını gösteren temsili senaryolar.'
    ),
  },
  '/accessibility': {
    title: T('Accessibility — Nexus Design AI', 'Erişilebilirlik — Nexus Design AI'),
    description: T(
      'Our accessibility statement: working toward WCAG 2.1 AA conformance.',
      'Erişilebilirlik bildirimimiz: WCAG 2.1 AA uyumluluğuna doğru çalışıyoruz.'
    ),
  },
  '/patent-mapping': {
    title: T('Confidential IP Review — Nexus Design AI', 'Gizli IP İncelemesi — Nexus Design AI'),
    description: T(
      'Public-safe patent-pending status and the process for confidential legal due diligence under NDA.',
      'Kamuya açık patent başvurusu durumu ve NDA kapsamındaki gizli hukuki inceleme süreci.'
    ),
  },
  '/gallery': {
    title: T('Gallery — Nexus Design AI', 'Galeri — Nexus Design AI'),
    description: T(
      'AI-generated design concepts from the Nexus community.',
      'Nexus topluluğundan AI üretimi tasarım konseptleri.'
    ),
  },
  '/applications': {
    title: T('Applications — Nexus Design AI', 'Uygulama Alanları — Nexus Design AI'),
    description: T(
      'Manufacturing, energy, medical, construction, maintenance and aerospace applications of Nexus Design AI.',
      'Nexus Design AI ile üretim, enerji, medikal, inşaat, bakım ve havacılık uygulamaları.'
    ),
  },
};

// Public demo projects allowed in the index; every other /projects/:id is noindex.
export const INDEXABLE_PROJECT_IDS = ['demo_nexus_protected_ip', 'proj_demo_showcase_001'];

// Route prefixes that must be noindex,nofollow.
export const PRIVATE_PREFIXES = [
  '/login', '/signup', '/dashboard', '/admin', '/project/', '/rnd-dashboard',
  '/mobile-debug', '/mobile-login', '/compose', '/payment', '/become-seller',
  '/auth', '/solutions', '/ar', '/companies', '/training', '/scanner', '/investors', '/nexus',
];

// Every static path declared in App.js. This is the authoritative answer to
// "does this URL exist?", which SEO_ROUTES cannot give: many real routes
// (/dashboard, /login, /studio, ...) intentionally have no marketing metadata,
// so a missing SEO_ROUTES entry must never be read as "page not found".
//
// src/seo/knownRoutes.test.js asserts this list matches App.js exactly, so the
// two cannot drift and a new page can never be served as a 404.
export const KNOWN_STATIC_ROUTES = [
  '/', '/about', '/accessibility', '/acquire', '/admin', '/applications', '/ar',
  '/become-seller', '/blog', '/case-studies', '/companies', '/compose', '/contact',
  '/dashboard', '/engines', '/faq', '/gallery', '/integrations', '/investor',
  '/investors', '/licensing', '/login', '/marketplace', '/mobile-debug', '/nexus',
  '/mobile-login', '/patent-mapping', '/payment/success', '/pricing', '/privacy',
  '/privacy-policy', '/projects', '/rnd-dashboard', '/scanner', '/security',
  '/security-policy', '/signup', '/solutions', '/studio', '/terms',
  '/terms-of-service', '/training', '/trust',
];

// Routes carrying a parameter. A bare prefix (/blog, /projects) is a static
// route above; only a single non-empty segment below it is a detail page.
const DYNAMIC_ROUTE_PATTERNS = [
  /^\/blog\/[^/]+$/,
  /^\/project\/[^/]+$/,
  /^\/projects\/[^/]+$/,
];

// Paths the app answers without a <Route>, so they are absent from the route
// table but are NOT 404s. /auth/callback is where Google OAuth returns: AppRouter
// intercepts it on the session_id hash before <Routes> is consulted. The build
// also prerenders a file for each of these, because once 404.html exists Render
// serves only paths that match a file.
export const ROUTELESS_PATHS = ['/auth/callback'];

const KNOWN_STATIC_ROUTE_SET = new Set([...KNOWN_STATIC_ROUTES, ...ROUTELESS_PATHS]);

// `route` must already be normalised (no trailing slash, '/' for the root).
export const isKnownRoute = (route) =>
  KNOWN_STATIC_ROUTE_SET.has(route) || DYNAMIC_ROUTE_PATTERNS.some((re) => re.test(route));
